// extracted by mini-css-extract-plugin
export var divider = "_h0-7";
export var itemsToggle = "_h0-8";
export var mergeModal = "_h0-1";
export var optionCard = "_h0-4";
export var radioGroup = "_h0-6";
export var radioOption = "_h0-0";
export var selected = "_h0-5";
export var shipmentOptions = "_h0-2";
export var tableOptions = "_h0-3";